export default "__VITE_ASSET__14fuJsMG__"